



























































import {Vue, Component, Prop} from 'vue-property-decorator';

@Component
export default class GroupBox extends Vue {

    //@ts-ignore
    @Prop(Array) items: any[];

    //@ts-ignore
    @Prop(Array) groups: any[];

    //@ts-ignore
    @Prop({default: 640}) mobileBreakpoint: number;


    menu: boolean = false;
    value: string = '';
    text: string = '';
    more_active: string = '';
    group_active: string = '';

    mounted(){
        this.$nextTick(()=>{
            this.adjustForWidth();
        });
        window.addEventListener('click', this.adjustForWidth.bind(this))
        window.addEventListener('resize', this.adjustForWidth.bind(this))
    }

    adjustForWidth(){
        try // not to crap in console
        {
            //@ts-ignore
            let width: number = this.$el.offsetWidth - 250;
            let chips = Array.from(this.$el.querySelectorAll('.v-chip'));
            let menu = Array.from(document.querySelectorAll('.single_item a'))
                .concat(Array.from(document.querySelectorAll('.group_item')));
            //@ts-ignore
            let desktopBox: HTMLElement = this.$el.querySelector('#desktop-view');
            //@ts-ignore
            if (this.$el.offsetWidth <= this.mobileBreakpoint)
            {
                menu.map((e) => {
                    (e as HTMLElement).style.display = '';
                });

                chips.map((e) => {
                    (e as HTMLElement).style.display = 'none';
                    if ((e as HTMLElement).id === 'menu')
                    {
                        let q = (e as HTMLElement).querySelector('.v-chip__content');
                        (e as HTMLElement).style.display = 'flex';
                        (e as HTMLElement).style.width = '100%';
                        (q as HTMLElement).style.justifyContent = 'space-between';
                    }
                });
                desktopBox.style.display = 'none';
                return;
            }

            desktopBox.style.display = '';

            menu.map((e) => {
                (e as HTMLElement).style.display = 'none';
            });

            chips.map((e) => {
                (e as HTMLElement).style.display = '';
            });


            let chipsWidth = 0;
            for (var i = 0; i < chips.length; i++) {
                chipsWidth += (chips[i] as HTMLElement).offsetWidth;
            }

            //@ts-ignore
            let menuButton : HTMLElement = this.$el.querySelector('#menu');
            menuButton.style.display = 'none';
            menuButton.style.width = '100%';

            //@ts-ignore
            menuButton.querySelector('.v-chip__content').style.justifyContent = 'space-between';

            let shown = chips.length;
            while (width < chipsWidth) {
                let chip: HTMLElement = chips.pop() as HTMLElement;
                chipsWidth -= chip.offsetWidth;
                if (chip.id !== 'menu') {
                    menuButton.style.display = 'flex';
                    chip.style.display = 'none';
                    --shown;
                }
                menu.map((e) => {
                    if (e.getAttribute('aria-label') === chip.getAttribute('aria-label')) {
                        (e as HTMLElement).style.display = '';
                    }
                });
            }




        }
        catch(e){
            //pass
        }

    }

    set(data: any, more_active: any){
        this.$emit('input', data.value);
        this.value = data.value;
        this.text = data.text;
        this.more_active = more_active || '';
        this.group_active = '';
    }

    setGroup(data: any, group_active: any){
        this.$emit('input', data.value);
        this.value = data.value;
        this.text = data.text;
        this.group_active = group_active || '';
        this.more_active = '';
    }

}
